<template>
    <div>
        <div class="container-fluid mt-6"
             v-if="course && course.skill_1">
            <div class="container">
                <div class="row">
                    <div class="col-12 skills-header">
                        {{ $t('we_will_learn') }}:
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid"
             v-if="course && course.skill_1">
            <div class="container mt-6">

                <div class="row">
                    <div class="col-12 px-lg-0 px-5">
                        <div class="skill-span skill-span-1" v-if="course.skill_1">{{ course.skill_1 }}</div>
                        <div class="skill-span skill-span-2" v-if="course.skill_2">{{ course.skill_2 }}</div>
                        <div class="skill-span skill-span-3" v-if="course.skill_3">{{ course.skill_3 }}</div>
                        <div class="skill-span skill-span-4" v-if="course.skill_4">{{ course.skill_4 }}</div>
                        <div class="skill-span skill-span-5" v-if="course.skill_5">{{ course.skill_5 }}</div>
                        <div class="skill-span skill-span-6" v-if="course.skill_6">{{ course.skill_6 }}</div>
                        <div class="skill-span skill-span-7" v-if="course.skill_7">{{ course.skill_7 }}</div>
                    </div>
                </div>
            </div><!-- /.container -->
        </div><!-- /.container-fluid -->
    </div>
</template>

<script>

    export default {
        name: 'CourseSkills',

        props: {
            course: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {}
        },

        mounted() {
        },

    }
</script>
<style scoped>
    @media (max-width: 991.8px) {
        .skills-preheader p {
            padding-left: 15px;
            padding-right: 15px;
        }
    }

    .skills-preheader, .skills-preheader p {
        color: #4f4d5c;
        font-size: 18px;
    }

    .skills-header {
        font-family: "Manrope Bold";
        font-size: 30px;
        color: #231c37;
        text-align: center;
    }

    .skill-wrapper {
        position: relative;
    }

    .skill-span {
        color: white;
        display: inline-block;
        font-weight: bold;
        font-size: 20px;
        line-height: 35px;
        border-radius: 17px;
        height: 35px;
        text-align: center;
        padding-left: 20px;
        padding-right: 20px;
        margin-right: 25px;
        margin-bottom: 30px;
    }

    .skill-span span {
        margin: auto 0;
    }

    .skill-span-1 {
        background-color: #b01ced;
    }

    .skill-span-2 {
        background-color: #00b4f1;

    }

    .skill-span-3 {
        background-color: #00963f;
    }

    .skill-span-4 {
        background-color: #33c416;
    }

    .skill-span-5 {
        background-color: #fa8500;
    }

    .skill-span-6 {
        background-color: #0450c3;
    }

    .skill-span-7 {
        background-color: #ed1c24;
    }

</style>
